import React from "react";
import ResumeView from "../../components/content/resume/ResumeView";
import SampleTeaching from "../../components/content/sample-teaching/SampleTeaching";
import "./LecturerInfoRoute.scss";
import {
  LecturerInfoRouteIProps,
  LecturerInfoRouteIState,
} from "./LecturerInfoRoute.models";

export default class LecturerInfoRoute extends React.PureComponent<LecturerInfoRouteIProps, LecturerInfoRouteIState> {
  constructor(props: any) {
    super(props);
    this.state = { statusPage: 0, authorId: 0, userId: "" };
  }

  componentDidMount() {
    this.setParams(
      this.props.userId,
      this.props.authorId,
      this.props.statusPage
    );
  }

  componentDidUpdate(prevProps: any) {
    if (prevProps.statusPage !== this.props.statusPage)
      this.setParams(
        this.props.userId,
        this.props.authorId,
        this.props.statusPage
      );

    if (prevProps.userId !== this.props.userId || prevProps.authorId !== this.props.authorId)
      this.setParams(
        this.props.userId,
        this.props.authorId,
        this.props.statusPage
      );
  }

  setParams = (
    userId?: string | null,
    authorId?: string | null,
    statusPage?: string | null
  ) => {
    if (statusPage !== null && statusPage !== undefined)
      this.setState((prevState) => {
        return { ...prevState, statusPage: Number.parseInt(statusPage) };
      });

    if (authorId !== undefined && authorId !== null)
      this.setState((prevState) => {
        return { ...prevState, authorId: Number(authorId) };
      });

    if (userId !== undefined && userId !== null)
      this.setState((prevState) => {
        return { ...prevState, userId: userId };
      });
  };

  render(): React.ReactNode {
    let { statusPage, userId } = this.state;
    let content;
    if (statusPage === 1) {
      content = (
        <>
          <ResumeView
            assistantUserId={this.state.userId}
            authorId={this.state.authorId}
          />
        </>
      );
    } else if (statusPage === 2) {
      content = (
        <>
          <SampleTeaching authorId={this.state.authorId}  height="80vh"/>
        </>
      );
    } else content = <></>;

    return (
      <>
        <div className="found-data lecturer-info">
          <div className="tk-header">
            <div className="tk-inline" style={{ paddingTop: "10px" }}>
              <div
                className={
                  "col-6 notspace tk-aling-center " +
                  (statusPage === 1 ? "activate " : "") +
                  (userId === null || userId === "" || userId === undefined
                    ? "col-6 "
                    : " col-12 ")
                }
                onClick={() => this.setState({ statusPage: 1 })}
              >
                <span className="tk-title tk-link">رزومه</span>
              </div>
              {userId === null || userId === "" || userId === undefined ? (
                <div
                  className={
                    "col-6 notspace tk-aling-center " +
                    (statusPage === 2 ? "activate" : "")
                  }
                  onClick={() => this.setState({ statusPage: 2 })}
                >
                  <span className="tk-title tk-link">نمونه تدریس‌ها</span>
                </div>
              ) : (
                <></>
              )}
            </div>
          </div>
          {content}
        </div>
      </>
    );
  }
}
